import useQuoteBuilder from './hooks/useQuoteBuilder'

import CampaignQuote from './components/CampaignQuote'
import QuoteBuilderContextProvider from '../QuoteBuilderContextProvider'

interface QuoteBuilderProps {
  quoteBuilderPayload: ReturnType<typeof useQuoteBuilder>,
}

const CampaignQuoteBuilder = (props: QuoteBuilderProps) => {
  const { quoteBuilderPayload } = props

  return (
    <QuoteBuilderContextProvider value={quoteBuilderPayload}>
      <CampaignQuote quoteBuilderPayload={quoteBuilderPayload} />
    </QuoteBuilderContextProvider>
  )
}

export default CampaignQuoteBuilder
